
$(document).ready(function() {


	$('.burger-icon').on('click', function(e) {
		setTimeout(function() { 
        	$(this).toggleClass("js-mobile-menu-icon js-close-mobile-menu"); //you can list several class names 
        }, 200);
	});
  	if ($('.full-width-image').hasClass('invert-header')) {
         $('[data-section-id="header"]').addClass('invert-header');
     }
  	if ($('.full-width-video').hasClass('invert-header')) {
         $('[data-section-id="header"]').addClass('invert-header');
     }

});


$('.js-slideshow-section').on({
  afterChange: function(event, slick, currentSlide, nextSlide) {
     if ($('.slick-active').hasClass('invert-header')) {
         $('[data-section-id="header"]').addClass('invert-header');
         $('.full-width-slideshow').addClass('invert-header');
     } else {
         $('[data-section-id="header"]').removeClass('invert-header');
         $('.full-width-slideshow').removeClass('invert-header');
     }
  }
});

var $videoDesktop = $("[data-section-type='full-width-video'] .video-desktop video");
var $videoMobile = $("[data-section-type='full-width-video'] .video-mobile video");
function videoHandler(){
    $videoDesktop[0][ $(window).width()<940 ? "pause" : "play" ]();
    $videoMobile[0][ $(window).width()>939 ? "pause" : "play" ]();
}
if($("[data-section-type='full-width-video'] .video-desktop video").length >0 ){
   $(window).on("resize load", videoHandler); 
}

$("#sound-on").click(function() {
    if ($("[data-section-type='full-width-video'] .video-desktop video").prop('muted')) {
    	$("[data-section-type='full-width-video'] .video-desktop video").prop('muted', false);
        $('#sound-on').text("SOUND OFF");
    } else {
    	$("[data-section-type='full-width-video'] .video-desktop video").prop('muted', true);
        $('#sound-on').text("SOUND ON");
    }
});
$("#sound-on-mobile").click(function() {
    if ($("[data-section-type='full-width-video'] .video-mobile video").prop('muted')) {
    	$("[data-section-type='full-width-video'] .video-mobile video").prop('muted', false);
        $('#sound-on-mobile').text("SOUND OFF");
    } else {
    	$("[data-section-type='full-width-video'] .video-mobile video").prop('muted', true);
        $('#sound-on-mobile').text("SOUND ON");
    }
});

$(document).ready(function() {
  	var width = $(document).width();
      if (width < 940) {
          setTimeout(function() { 
              $('.js-get-the-look-slider').not('.slick-initialized').slick({
                  infinite: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  swipeToSlide: true,
                  centerMode: true,
                  centerPadding: '0%',
                  dots: false,
                  prevArrow: $('.get-the-look-controls .prev', this.$container),
                  nextArrow: $('.get-the-look-controls .next', this.$container)
              });
          }, 200);
      } else {
		  setTimeout(function() { 
              $('.js-press-collaborations-slider').not('.slick-initialized').slick({
                  infinite: false,
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  dots: false,
                  prevArrow: $('.press-collaborations-controls .prev', this.$container),
                  nextArrow: $('.press-collaborations-controls .next', this.$container)
              });
          }, 200);
      }
    $(window).resize(function() {
      var width = $(document).width();
      if (width < 940) {
          setTimeout(function() { 
              $('.js-get-the-look-slider').not('.slick-initialized').slick({
                  infinite: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  swipeToSlide: true,
                  centerMode: true,
                  centerPadding: '0%',
                  dots: false,
                  prevArrow: $('.get-the-look-controls .prev', this.$container),
                  nextArrow: $('.get-the-look-controls .next', this.$container)
              });
          }, 200);
          setTimeout(function() { 
            	$('.js-press-collaborations-slider.slick-initialized').slick('unslick');
            }, 200);
      } else {
          setTimeout(function() { 
                $('.js-get-the-look-slider.slick-initialized').slick('unslick');
            	$('.js-press-collaborations-slider').not('.slick-initialized').slick({
                    infinite: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: false,
                    prevArrow: $('.press-collaborations-controls .prev', this.$container),
                    nextArrow: $('.press-collaborations-controls .next', this.$container)
                });
            }, 200);
      }
    }).resize();
});

$('.toggle').click(function(e) {
  	e.preventDefault();
  
    var $this = $(this);
  
  	if ($this.hasClass('shown')) {
        $this.removeClass('shown');
    } else {
        $this.parent().parent().find('a').removeClass('shown');
        $this.toggleClass('shown');
    }
  
    if ($this.next().hasClass('shown')) {
        $this.next().removeClass('shown');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('li .inner').removeClass('shown');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('shown');
        $this.next().slideToggle(350);
    }
});

$(function(){
  var soldoutHover;    

  $('.clickyboxes li a.unavailable').hover(function(){
  soldoutHover = $('[data-add-to-cart-text]').text();
      $('[data-add-to-cart-text]').text("Sold Out");
  }, function(){
      $('[data-add-to-cart]:not([disabled]) [data-add-to-cart-text]').text(soldoutHover)
  });
})

$(function(){
  var addtocartHover;    

  $('.clickyboxes li a:not(.unavailable)').hover(function(){
  addtocartHover = $('[data-add-to-cart-text]').text();
      $('[data-add-to-cart-text]').text("Add to Cart");
  }, function(){
      $('[data-add-to-cart][disabled] [data-add-to-cart-text]').text(addtocartHover)
  });
})

$('.clickyboxes li a.unavailable').click(function(e) {
	setTimeout(function() { 
		$('#notifyConfig').show();
	}, 200);
});
$('.clickyboxes li a:not(.unavailable)').click(function(e) {
	setTimeout(function() { 
		$('#notifyConfig').hide();
	}, 200);
});


$('.notify__btn').click(function(e) {
    e.preventDefault();
    var email = $('.js-notify-email').val(),
        productId = $('.js-notify-form').attr("data-product-id"),  
        variantId = $('.js-notify-form').attr("data-variant-id");
    if ($('.js-notify-form').attr("data-variant-id")) {
		BIS.create(email, variantId, productId).then(notificationCallback); // create the notification
    } else {
      $('#notifyMessageConfig .notify__response-error').text('Please select a size').show();
      $('#notifyMessageConfig .notify__response-success').hide();
      $('#notifyConfig .notify__btn').css("background-color","#8D8D8D");
    }
});

var notificationCallback = function(data) {
    var msg = '';
    if (data.status == 'OK') {
      msg = data.message; // just show the success message
      $('#notifyMessageConfig .notify__response-success').text(msg).show();
      $('#notifyMessageConfig .notify__response-error').hide();
      $('#notifyConfig .notify__btn').css("background-color","transparent");
    } else { // it was an error
      for (var k in data.errors) {  // collect all the error messages into a string
         msg += (data.errors[k].join());
       }
      $('#notifyMessageConfig .notify__response-error').text(msg).show();
      $('#notifyMessageConfig .notify__response-success').hide();
      $('#notifyConfig .notify__btn').css("background-color","#8D8D8D");
    }
}


$(document).ready(function() {

  if ($(".product-form").hasClass("variant--unavailable")) {
    $('#notifyConfig').show();
  }
  $('.coming-soon .clickyboxes li a').removeClass('active');
  setTimeout(function() { 
  	$('.coming-soon .clickyboxes li a').css("visibility","visible");
  }, 300);

});


$(".site-nav__item--has-dropdown").hover(
  function () {
    $(".site-header").addClass("header_hover");
  },
  function () {
    $(".site-header").removeClass("header_hover");
  }
);
$(".header-cart").hover(
  function () {
    $(".site-header").addClass("header_hover");
  },
  function () {
    $(".site-header").removeClass("header_hover");
  }
);




var $table = $('#size-chart table');

  $('.js-toggle-measurement').on('click', function(){
    if ($(this).data('active') == true) {
      return;
    }

    $(this).attr('data-active', true);
    $(this).siblings().attr('data-active', false)

    if ($(this).data('val') == 'cms') {
      $table.find('td').each(function(){
        var measurement = parseFloat($(this).html())
        if (!isNaN(measurement)) {
          measurement = round((measurement * 2.54), 2)
          $(this).html(measurement)
        }
      })
    }else{
      $table.find('td').each(function(){
        var measurement = parseFloat($(this).html())
        if (!isNaN(measurement)) {
          measurement = round((measurement / 2.54), 2)
          $(this).html(measurement)
        }
      })
    }
  })
  function round(value, exp) {
    if (typeof exp === 'undefined' || +exp === 0)
      return Math.round(value);

    value = +value;
    exp = +exp;

    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
      return NaN;

    // Shift
    value = value.toString().split('e');
    value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));

    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
  }